// extracted by mini-css-extract-plugin
export default {"video":"u3OuJH9niM1HenoN0dey"};